export default __webpack_public_path__ + "2baef6398a441b2988abd235ef547adc.svg";